import { render, staticRenderFns } from "./update-password-modal.vue?vue&type=template&id=5a8b2e07&scoped=true&"
import script from "./update-password-modal.vue?vue&type=script&lang=js&"
export * from "./update-password-modal.vue?vue&type=script&lang=js&"
import style0 from "./update-password-modal.vue?vue&type=style&index=0&id=5a8b2e07&scoped=true&lang=css&"
import style1 from "./update-password-modal.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a8b2e07",
  null
  
)

export default component.exports